import { useCallback, type RefObject } from "react";
import { FOCUSABLE_ELEMENT_SELECTOR } from "../../constants/constants";

/**
 * Hook that provides functionality to focus the first focusable element within a container
 * @param containerRef - A ref object pointing to the container element
 * @returns Function to focus the first focusable element
 */
export const useFocusFirstElement = (
  containerRef: RefObject<HTMLElement | null>,
) => {
  const focusFirstElement = useCallback(() => {
    const firstFocusable = containerRef?.current?.querySelector(
      FOCUSABLE_ELEMENT_SELECTOR,
    ) as HTMLElement;

    if (firstFocusable) {
      firstFocusable.focus();
    }
  }, [containerRef]);

  return { focusFirstElement };
};
